import type { ReactNode } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { useIntl } from 'react-intl';
import { parseBackendMessage } from '../BackendMessageParser/BackendMessageParser';
import { getFieldError } from './AddressValidation';

type AdditionalFieldMessages = Record<string, Record<string, MessageDescriptor>>;

export const useValidationHelperText = (
  additionalMessages?: AdditionalFieldMessages,
  /** Values for messages that carry a placeholder, e.g. the tenant's minimum registration age. */
  values?: Record<string, string | number>,
) => {
  const { formatMessage } = useIntl();
  return (fieldName: string, error?: { type?: string; message?: string }): ReactNode => {
    if (!error?.message) return undefined;
    if (error.type === 'manual') return parseBackendMessage(error.message);
    const custom = additionalMessages?.[fieldName]?.[error.message];
    if (custom) return formatMessage(custom, values);
    return formatMessage(getFieldError(error.message, fieldName), values);
  };
};
